module.exports = __webpack_public_path__ + "static/media/linkedin.7fb99744.png";